import { Component, OnInit, ViewChild, Renderer2, Inject, ElementRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { LoaderService } from 'src/app/service/shared/loader/loader.service';
import { JobsService } from 'src/app/service/jobs/jobs.service';
import { OwnerInfoService } from 'src/app/service/owner-info/owner-info.service';
import { BillingDueDateTypesService } from 'src/app/service/billing-due-date-types/billing-due-date-types.service';
import { DepartmentService } from 'src/app/service/department/department.service';
import { InvoicesService } from 'src/app/service/invoices/invoices.service';
import { MomentService } from 'src/app/service/shared/moment/moment.service';
import { UsersService } from 'src/app/service/users/users.service';
import { WorkingStatusService } from 'src/app/service/working-status/working-status.service';
import { JobAuditTrailService } from 'src/app/service/job-audit-trail/job-audit-trail.service';
import { IpAddressService } from 'src/app/service/ip-address/ip-address.service';
import { LocalstorageService } from 'src/app/service/shared/localstorage/localstorage.service';
import { PotentialJobsWorkingCommentsService } from 'src/app/service/potential-jobs-working-comments/potential-jobs-working-comments.service';
import { ToastService } from 'src/app/service/shared/toast/toast.service';
import { ExportToCsv } from 'export-to-csv';
import { Router } from '@angular/router';
import getAndParseUserPermissions from 'src/app/helpers/parsePermissions';

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.scss'],
})
export class InvoicesComponent implements OnInit {
  @ViewChild('invoiceTable') invoiceTable;
  @ViewChild('closeFilterModel') closeFilterModel;
  @ViewChild('closebutton1') closebutton1;
  @ViewChild('chatModal') chatModal;
  @ViewChild('messagesPdf') messagesPdf;
  @ViewChild('inputField') inputField: ElementRef<HTMLInputElement>

  newData = [];
  jobsData = [];
  invoiceData = [];
  userPermissions;
  user;
  disableAssistantSelect: boolean = false;
  jobNumbers: any = [];
  projectNames: any = [];
  projectManagerData: any = [];
  projectManagerNames: any = [];
  ProjectAssistantData: any = [];
  projectAssistantNames: any = [];
  projectForemanData: any = [];
  projectForemanNames: any = [];
  workingStatusData: any = [];
  potentialJobsWorkingCommentsData: any = [];
  arCustomerData = [];
  ownersData = [];
  departmentsData = [];
  jobStatus = [];
  invoiceStatusData = [];
  invoiceStatusDescription = [];
  typeOfBillingData = [];
  typeOfBillingDescription = [];
  dueDateBillingTypeData = [];
  dueDateBillingTypeDescription = [];
  defaultSearch = {
    user_id: '',
    project_manager_id: '',
    assistant_id: '',
    contact_ar_customer_name_id: '',
    status: '2,3,4',
    search: '',
    contact_type_of_billing: '',
    owner_id: '',
    department_codes: '',
    invoice_status: '',
    start: 0,
    limit: 500,
    sort_field: 'main_assistant_name',
    sort_order: 'asc',
  };
  searchInfo = Object.assign({}, this.defaultSearch);
  deleteJobId;
  ipAddress;
  userId;
  jobId;
  jobDetail;
  commentType;
  user_message;
  type = 'asc';
  lastDataNumber = 0;
  totalCount = 0;
  sortBy = '';
  messages = [];
  invoiceStatusOptionsList: string = '';

  constructor(
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private _document,
    private router: Router,
    private loaderService: LoaderService,
    private jobsService: JobsService,
    private ownerInfoService: OwnerInfoService,
    private billingDueDateTypesService: BillingDueDateTypesService,
    private departmentService: DepartmentService,
    private invoicesService: InvoicesService,
    private usersService: UsersService,
    private momentService: MomentService,
    private jobAuditTrailService: JobAuditTrailService,
    private ipAddressService: IpAddressService,
    private localStorageService: LocalstorageService,
    private workingStatusService: WorkingStatusService,
    private potentialJobsWorkingCommentsService: PotentialJobsWorkingCommentsService,
    private toastService: ToastService,
  ) {
    this.userId = this.localStorageService.getItem('userId');
    this.getIP();
    this.userPermissions = getAndParseUserPermissions(this.localStorageService)
    this.getUserInformation(this.userId).then(() => {
      if (this.user.role_id === 7) {
        this.disableAssistantSelect = true;
      }
      this.establishDefaultSearchSettings();

      //To get saved filter data if exist
      let filterData = this.localStorageService.getItem('invoicesFilter');
      if (filterData) {
        this.searchInfo = JSON.parse(filterData);
      }
      this.setSelect2MultipleWithCheck();
    });
  }

  ngOnInit(): void {
    this.loaderService.displayLoader();

    Promise.resolve()
      .then(() => {
        return Promise.all([
          this.getJobStatuses(),
          this.getInvoicesData(),
          this.getBillingDueDateTypes(),
          this.getWorkingStatus(),
          this.getUsers(),
          this.getOwners(),
          this.getDepartments(),
          this.getARCustomer(),
        ]);
      })
      .then(() => this.getJobs())
      .then(() => {
        this.loadToggle();
        this.loadInvoiceDataOnScroll();
        this.loadSelect2();
        this.loadSelect2MultipleWithCheck();
      })
      .catch(error => {
        console.error('Error retrieving invoices:', error);
        this.loaderService.hideLoader();
      });
  }

  //Get profile for the logged in user
  getUserInformation(userId) {
    return new Promise((resolve, reject) => {
      this.usersService.getUsersById(userId).subscribe(
        res => {
          this.user = res.data;
          resolve(true);
        },
        error => {
          reject(error);
        },
      );
    });
  }

  //Establish the default search object for this user
  establishDefaultSearchSettings() {
    this.defaultSearch.user_id = this.userId;
    this.defaultSearch.assistant_id = this.user.role_id === 7 ? this.user.id : '';
    this.searchInfo = Object.assign({}, this.defaultSearch);
  }

  //To get all potential jobs working comments
  createMessage(jobId: string, message: string, userId: number, commentType: string) {
    return new Promise((resolve, reject) => {
      if (!jobId || !message.trim()) return reject('Message cannot be empty');

      const newMessage = {};
      newMessage['potential_job_detail_id'] = jobId;
      newMessage['comment'] = message.trim();
      newMessage['user_id'] = userId;
      newMessage['comment_type'] = commentType;

      //Service call to create new working comments data
      this.potentialJobsWorkingCommentsService.createPotentialJobsWorkingComments(newMessage).subscribe(
        res => {
          this.onMessageSaveSuccess(res, jobId, commentType);
          const input = <HTMLInputElement>window.document.getElementById(`commentTxt-${jobId}`);
          input.value = '';
          resolve(true);
        },
        error => {
          this.onMessageSaveError(error);
          reject();
        },
      );
    });
  }

  //On success of working status api call
  onMessageSaveSuccess(result, jobId, commentType) {
    if (result?.data && commentType !== 'invc') {
      this.getMessages(jobId, commentType);
    }
  }

  //On error of working status api call
  onMessageSaveError(_) { }

  //To get all potential jobs working comments
  getMessages(jobId: number, commentType: string) {
    return new Promise((resolve, reject) => {
      //this.messagesLoaded = false;

      //Service call to get all working comments data
      this.potentialJobsWorkingCommentsService
        .getPotentialJobsWorkingCommentsByJobId(jobId, commentType, {
          includeInvoices: 1,
        })
        .subscribe(
          res => {
            this.onGetMessagesSuccess(res);
            resolve(true);
          },
          error => {
            this.onGetMessagesError(error);
            reject();
          },
        );
    });
  }

  //On success of working status api call
  onGetMessagesSuccess(result) {
    if (!result?.data) return;

    this.messages = result.data;

    this.messages.forEach(msg => {
      msg.created_date = this.momentService.getGeneralDateFormat(msg.created_date, 'M/DD/YYYY h:mm A');
    });

    setTimeout(() => {
      this.scrollToBottom('chatBlock');
    }, 250);

    setTimeout(() => {
      this.focusInputField()
    }, 500)
  }

  //On error of working status api call
  onGetMessagesError(_) { }

  //To get all jobs
  getJobs(isConcat = false) {
    //Service call to get all jobs data
    if (!isConcat) {
      this.jobsData.splice(0, this.jobsData.length);
    }

    return new Promise((resolve, reject) => {
      this.invoicesService.getInvoiceJobData(this.searchInfo).subscribe(
        res => {
          this.onJobsSuccess(res, isConcat);
          resolve(true);
        },
        error => {
          this.onJobsError(error);
          reject(false);
        },
      );
    });
  }

  //On success of jobs api call
  onJobsSuccess(result, isConcat = false) {
    if (!result?.data?.data?.length) {
      this.loaderService.hideLoader();
      return;
    }

    this.newData = result.data.data;
    this.newData.forEach(record => {
      record['created_date'] = record['job_creation_date']
        ? this.momentService.getGeneralDateMedFormat(record['job_creation_date'])
        : '';
      let val = record['invoice_status'];
      let selectedStyle = `selected-${this.invoiceStatusDescription[val].toLowerCase().replace(/ /g, '-')}`;
      record['invoice_status_select'] = this.invoiceStatusOptionsList
        .replace(/#class/, selectedStyle) //assigning selected class to wrapper div
        .replace(/#id/, record.id) // replace template variable with record.id
        .replace(RegExp(`#sel${val}`), `selected`) // replace matching template variable with 'selected'
        .replace(/#sel\d/g, ''); // remove all remaining '#sel' template variables
      record['contact_type_of_billing'] = this.typeOfBillingDescription[record['contact_type_of_billing']];
      record['contact_billing_due_date_type'] =
        this.dueDateBillingTypeDescription[record['contact_billing_due_date_type']];
      record['job_link'] = `<a href="/jobs/${record.id}" class='text-blue' target='_blank'>${record.number}</a>`;
      let deptList = '';
      const jobs = record.potential_jobs.sort((a, b) => (a.department_number > b.department_number ? 1 : -1));
      for (const job of jobs) {
        if (job.is_main_job) {
          record['main_job_dept'] = job.department_number;
          record['project_manager_name'] = this.projectManagerNames[`${job.project_manager_id}`];
          record['project_assistant_name'] = this.projectAssistantNames[`${job.assistant_id}`];
          record['project_foreman_name'] = this.projectForemanNames[`${job.foreman_id}`];
        }
        deptList += deptList ? `,${job.department_number}` : job.department_number;
      }
      record['departments_list'] = deptList;
    });
    //Assign jobs result data to jobsData
    this.invoiceData = [];
    this.totalCount = result.data.count;

    if (isConcat) {
      this.jobsData = this.newData;
    } else {
      this.jobsData = this.jobsData.concat(this.newData);
    }

    if (this.jobsData) {
      this.lastDataNumber = this.jobsData.length;
    } else {
      this.lastDataNumber = 0;
    }

    let count = 0;

    if (!!result?.data?.data?.length) {
      this.jobsData.forEach(element => {
        count++;
        if (element.assistant_id) {
          if (!this.invoiceData[element.assistant_id]) {
            this.invoiceData[element.assistant_id] = [];
            this.invoiceData[element.assistant_id].name = element.project_assistant_name;
          }

          if (!this.invoiceData[element.assistant_id]['data']) {
            this.invoiceData[element.assistant_id]['data'] = [];
          }

          if (!this.invoiceData[element.assistant_id]['data'][element.project_manager_id]) {
            this.invoiceData[element.assistant_id]['data'][element.project_manager_id] = [];
            this.invoiceData[element.assistant_id]['data'][element.project_manager_id].name =
              element.project_manager_name;
          }

          if (!this.invoiceData[element.assistant_id]['data'][element.project_manager_id]['data']) {
            this.invoiceData[element.assistant_id]['data'][element.project_manager_id]['data'] = [];
          }
          if (this.invoiceData[element.assistant_id]['data'][element.project_manager_id]['data']) {
            this.invoiceData[element.assistant_id]['data'][element.project_manager_id]['data'].push(element);
          }
        }

        if (this.jobsData.length !== count) return;

        if (this.jobsData.length > 0) {
          this.createTableStructureWithData();
          return;
        }

        this.loadMoreData();
      });
    }
  }

  createTableStructureWithData() {
    this.loaderService.displayLoader();
    this.clearHTMLforTag('#invoiceTable');
    this.destroyUpdateDataTable();
    let classes = 'tablesorter-header tablesorter-headerUnSorted'; //todo: need to determine what will be sort default and remove 'unsorted' class for it
    let headers = [
      {
        title: 'Assistant',
        classList: classes,
        field: 'main_assistant_name',
        dbField: 'main_assistant_name',
      },
      {
        title: 'Project Manager',
        classList: classes,
        field: 'main_project_manager_name',
        dbField: 'main_project_manager_name',
      },
      {
        title: 'Project Name',
        classList: classes,
        field: 'name',
        dbField: 'name',
      },
      {
        title: 'Job #',
        classList: classes,
        field: 'job_link',
        dbField: 'number',
      },
      {
        title: 'Dept',
        classList: classes,
        field: 'department_codes',
        dbField: 'department_codes',
      },
      {
        title: 'Job Created',
        classList: classes,
        field: 'created_date',
        dbField: 'job_creation_date',
      },
      {
        title: 'Bill Due',
        classList: classes,
        field: 'contact_billing_due_date_type',
        dbField: 'contact_billing_due_date_type',
      },
      {
        title: 'Billing Type',
        classList: classes,
        field: 'contact_type_of_billing',
        dbField: 'contact_type_of_billing',
      },
      {
        title: 'Cust ID',
        classList: classes,
        field: 'customer_code',
        dbField: 'customer_code',
      },
      {
        title: 'PO#',
        classList: classes,
        field: 'contact_purchse_order',
        dbField: 'contact_purchse_order',
      },
      {
        title: 'Foreman',
        classList: classes,
        field: 'main_foreman_name',
        dbField: 'main_foreman_name',
      },
      {
        title: 'Invoice Status',
        classList: classes,
        field: 'invoice_status_select',
        dbField: 'invoice_status',
      },
      { title: '', classList: classes, field: '', dbField: '' },
    ];

    let html;
    html += `<thead>
                <tr>
                  <th class="${headers[0].classList}" onclick="sortInvoiceData('.newInvoiceCustomerSortData','${headers[0].dbField}','${this.type}')">${headers[0].title}</th>
                  <th class="${headers[1].classList}" onclick="sortInvoiceData('.newInvoiceCustomerSortData','${headers[1].dbField}','${this.type}')">${headers[1].title}</th>
                  <th class="${headers[2].classList}" onclick="sortInvoiceData('.newInvoiceCustomerSortData','${headers[2].dbField}','${this.type}')">${headers[2].title}</th>
                  <th class="${headers[3].classList}" onclick="sortInvoiceData('.newInvoiceCustomerSortData','${headers[3].dbField}','${this.type}')">${headers[3].title}</th>
                  <th class="${headers[4].classList}" onclick="sortInvoiceData('.newInvoiceCustomerSortData','${headers[4].dbField}','${this.type}')">${headers[4].title}</th>
                  <th class="${headers[5].classList}" onclick="sortInvoiceData('.newInvoiceCustomerSortData','${headers[5].dbField}','${this.type}')">${headers[5].title}</th>
                  <th class="${headers[6].classList}" onclick="sortInvoiceData('.newInvoiceCustomerSortData','${headers[6].dbField}','${this.type}')">${headers[6].title}</th>
                  <th class="${headers[7].classList}" onclick="sortInvoiceData('.newInvoiceCustomerSortData','${headers[7].dbField}','${this.type}')">${headers[7].title}</th>
                  <th class="${headers[8].classList}" onclick="sortInvoiceData('.newInvoiceCustomerSortData','${headers[8].dbField}','${this.type}')">${headers[8].title}</th>
                  <th class="${headers[9].classList}" onclick="sortInvoiceData('.newInvoiceCustomerSortData','${headers[9].dbField}','${this.type}')">${headers[9].title}</th>
                  <th class="${headers[10].classList}" onclick="sortInvoiceData('.newInvoiceCustomerSortData','${headers[10].dbField}','${this.type}')">${headers[10].title}</th>
                  <th class="${headers[11].classList}" onclick="sortInvoiceData('.newInvoiceCustomerSortData','${headers[11].dbField}','${this.type}')">${headers[11].title}</th>
                  <th class="/*sorter-false*/" width="100">${headers[12].title}</th>
                </tr>
            </thead>`;
    this.appendHTMLtoTag('#invoiceTable', html);

    this.appendHTMLtoTag('#invoiceTable', '<tbody class="header">');
    this.jobsData.forEach(record => {
      let contractTotal = 0;
      let estCostTotal = 0;
      let jtdCostTotal = 0;
      let jtdBilledTotal = 0;
      let jtdProfitTotal = 0;
      let openARTotal = 0;
      let jobLastInvoiceDate = null;
      if (record) {
        this.projectNames[record.id] = record.name;
        this.jobNumbers[record.id] = record.number;
        let invoiceDetailRows = record['jobs'].reduce((rows, dept) => {
          const contractAmt = this.formatToInteger(dept.contractTotal);
          const estCostAmt = this.formatToInteger(dept.estimatedCost) + this.formatToInteger(dept.extrasEstimatedCost);
          const jtdCostAmt = this.formatToInteger(dept.jtdCost) + this.formatToInteger(dept.extrasJtdCost);
          const jtdBilledAmt = this.formatToInteger(dept.jtdBilled);
          const jtdProfitAmt = jtdBilledAmt - jtdCostAmt;
          const openARAmt = this.formatToInteger(dept.openAr) + this.formatToInteger(dept.jtdRetainageHeld);
          const lastInvoice = dept.lastInvoiceDate;
          jobLastInvoiceDate = this.momentService.determineLatestDate(jobLastInvoiceDate, lastInvoice);
          contractTotal += contractAmt;
          estCostTotal += estCostAmt;
          jtdCostTotal += jtdCostAmt;
          jtdBilledTotal += jtdBilledAmt;
          jtdProfitTotal += jtdProfitAmt;
          openARTotal += openARAmt;
          rows += `
            <tr>
              <td>
                <div>${record['number']}-${dept.departmentNumber}</div>
                ${this.addNegativeSpan(this.formatToCurrency(contractAmt))}
              </td>
              <td>${this.addNegativeSpan(this.formatToCurrency(estCostAmt))}</td>
              <td>${this.addNegativeSpan(this.formatToCurrency(jtdCostAmt))}</td>
              <td>${this.addNegativeSpan(this.formatToCurrency(jtdBilledAmt))}</td>
              <td>${this.addNegativeSpan(this.formatToCurrency(jtdProfitAmt))}</td>
              <td>${this.addNegativeSpan(this.formatToCurrency(openARAmt))}</td>
              <td>${lastInvoice ? this.momentService.getGeneralDateFormat(lastInvoice) : 'N/A'}</td>
            </tr>
            `;
          return rows;
        }, '');

        record.contractTotal = contractTotal;
        record.estCostTotal = estCostTotal;
        record.jtdCostTotal = jtdCostTotal;
        record.jtdBilledTotal = jtdBilledTotal;
        record.jtdProfitTotal = jtdProfitTotal;
        record.openARTotal = openARTotal;
        record.jobLastInvoiceDate = jobLastInvoiceDate;

        invoiceDetailRows += `
          <tr class='footer'>
            <td>
              <div>Total</div>
              ${this.addNegativeSpan(this.formatToCurrency(contractTotal))}
            </td>
            <td>${this.addNegativeSpan(this.formatToCurrency(estCostTotal))}</td>
            <td>${this.addNegativeSpan(this.formatToCurrency(jtdCostTotal))}</td>
            <td>${this.addNegativeSpan(this.formatToCurrency(jtdBilledTotal))}</td>
            <td>${this.addNegativeSpan(this.formatToCurrency(jtdProfitTotal))}</td>
            <td>${this.addNegativeSpan(this.formatToCurrency(openARTotal))}</td>
            <td></td>
          </tr>
        `;
        let html1 = `
                  <tr>
                    <td style='width:8%;'><span class='textOverflow' style=''>${record[headers[0].field] ? record[headers[0].field] : ''
          }</span></td>
                    <td style='width:8%;'><span class='textOverflow' style=''>${record[headers[1].field] ? record[headers[1].field] : ''
          }</span></td>
                    <td style='width:8%;'>
                      <span
                        class='textOverflow'
                        style=''
                        data-toggle='tooltip' data-placement='top'
                        title='${record[headers[2].field] ? record[headers[2].field] : ''}'
                      >
                        ${record[headers[2].field] ? record[headers[2].field] : ''}
                      </span>
                    </td>
                    <td style='width:8%;'><span class='textOverflow' style='white-space: nowrap;'>${record[headers[3].field] ? record[headers[3].field] : ''
          }</span></td>
                    <td style='width:8%;'><span class='textOverflow' style=''>${record[headers[4].field] ? record[headers[4].field] : ''
          }</span></td>
                    <td style='width:8%;'><span class='textOverflow' style='min-width:11ch;'>${record[headers[5].field] ? record[headers[5].field] : ''
          }</span></td>
                    <td style='width:8%;'><span class='textOverflow' style='min-width:6ch;'>${record[headers[6].field] ? record[headers[6].field] : ''
          }</span></td>
                    <td style='width:8%;'><span class='textOverflow' style='min-width:10ch;'>${record[headers[7].field] ? record[headers[7].field] : ''
          }</span></td>
                    <td style='width:8%;'><span class='textOverflow' style=''>${record[headers[8].field] ? record[headers[8].field] : ''
          }</span></td>
                    <td style='width:8%;'>
                      <span
                        class='textOverflow'
                        style='max-width:10ch;'
                        data-toggle='tooltip' data-placement='top'
                        title='${record[headers[9].field] ? record[headers[9].field] : ''}'
                      >
                        ${record[headers[9].field] ? record[headers[9].field] : ''}
                      </span>
                    </td>
                    <td style='width:8%;'><span class='textOverflow' style='max-width:10ch;'>${record[headers[10].field] ? record[headers[10].field] : ''
          }</span></td>
                    <td style='width:8%;' class='reduced-padding-y'><span class='textOverflow' style='width:16ch;'>${record[headers[11].field] ? record[headers[11].field] : ''
          }</span></td>
                    <td style='' class='invoice-row-comments-column reduced-padding-x'>
                      <a href="#" class="comment job-comments-modal-trigger" id="${record.id
          }" data-toggle="modal" data-target="#chat-modal">
                        <i class="fas fa-comment-alt"></i>
                      </a>
                      &nbsp;
                      <a
                        class="invoice-details-expand-btn"
                        data-toggle="collapse"
                        href="#collapseDetail-${record.id}"
                        role=""
                        aria-expanded="false"
                        aria-controls="collapseDetail"
                      >
                        <i class="fas fa-chevron-down"></i>
                      </a>
                    </td>
                  </tr>
                  <tr class='invoice-row-details'>
                    <td colspan='13'>
                      <div class='row collapse' id='collapseDetail-${record.id}'>
                        <div class='col-2'>
                            <div class='invoice-overview'>
                              <div>Contract Total<span>${this.addNegativeSpan(
            this.formatToCurrency(contractTotal),
          )}</span></div>
                              <div>Last Invoice Date<span>${jobLastInvoiceDate ? this.momentService.getGeneralDateFormat(jobLastInvoiceDate) : 'N/A'
          }</span></div>
                            </div>
                        </div>
                        <div class='col-6' style='max-width:100%;'>
                            <table class='table invoice-details-table'>
                              <thead>
                                <tr>
                                  <th>Contract</th>
                                  <th>Est. Cost</th>
                                  <th>JTD Cost</th>
                                  <th>JTD Billed</th>
                                  <th>JTD Profit</th>
                                  <th>Open AR</th>
                                  <th>Last Invoice</th>
                                </tr>
                              </thead>
                              <tbody>
                                ${invoiceDetailRows}
                              </tbody>
                            </table>
                        </div>
                        <div class='col'>
                          <div class='invoice-details-notes'>
                            <div class='note-expand-button'>
                              <button id="acct-comments-${record.id
          }" class='btn btn-circle-sm acct-comments-modal-trigger' data-toggle="modal" data-target="#chat-modal">
                                <i class="fas fa-expand-alt"></i>
                              </button>
                            </div>
                            <div id='note-list-${record.id}' class='note-list'>
                            </div>
                            <div class='note-functions'>
                              <div class='note-input'>
                                <input id='commentTxt-${record.id
          }' class='focus-text-input' autofocus type='text' placeholder='Enter accounting notes here...' class='commentTxt' ></input>
                                <button id='commentBtn-${record.id
          }' class='btn btn-circle-sm commentBtn'><i class="fas fa-paper-plane"></i></button>
                              </div>
                              <button id='btn-printer-acct-${record.id
          }' class='btn btn-circle-sm btn-printer btn-printer-acct' data-toggle="modal" data-target="#pdf-comments"><i class="fas fa-print"></i></button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>`;
        this.appendHTMLtoTag('#invoiceTable', html1);
        setTimeout(() => {
        document.querySelectorAll('.focus-text-input').forEach((input) => {
          const newInput = input.cloneNode(true) as HTMLInputElement;
          input.parentNode?.replaceChild(newInput, input);

          newInput.addEventListener('keypress', (event: KeyboardEvent) => {
            if (event.key === 'Enter') {
              const target = event.target as HTMLInputElement;
              const recordId = target.id.split('-')[1];
              document.getElementById(`commentBtn-${recordId}`)?.click();
            }
          });
        });
      }, 0);
      }
      this.appendHTMLtoTag('#invoiceTable', '</tbody>');
    });
    setTimeout(() => {
      setTimeout(() => {
        this.loadToggle();
        this.updateDatatable();
        this.loadTooltip();
        this.loadScroller();
        this.setCommentIconColor();
        this.addCollapseListeners();
        this.addModalListenerToCommentButtons('job-comments-modal-trigger', 'job');
        this.addModalListenerToCommentButtons('acct-comments-modal-trigger', 'acct');
        this.addCreateMsgListenerToTxtInputElement();
        this.addCreateMsgListenerToSubmitButton();
        this.addRefreshNotesListenerToNoteListSection();
        this.addChangeListenerToInvoiceStatusSelect();
        this.addPrintPdfListenerToPrinterButton();
      }, 100);

      this.loaderService.hideLoader();
    }, 500);
  }

  assignChatJobId(jobId: string | number, commentType: string) {
    this.jobDetail = null;
    this.commentType = commentType;
    const jobResult = this.jobsData.filter(item => item.id == jobId);

    if (jobResult.length > 0) {
      this.jobDetail = jobResult[0];
    }
  }

  setCommentIconColor() {
    return new Promise(resolve => {
      this.potentialJobsWorkingCommentsService.getJobsWithComments({ types: '"job", "invc"' }).subscribe(
        result => {
          if (result.data.length) {
            const jobIdList = result.data;
            const jobCommentIcons = document.getElementsByClassName('comment');
            for (let i = 0; i < jobCommentIcons.length; i++) {
              const iconId = jobCommentIcons[i].getAttribute('id');
              if (jobIdList.includes(parseInt(iconId))) {
                document.getElementById(iconId).classList.add('danger');
              }
            }
            resolve(true);
          }
        },
        error => {
          resolve(false);
        },
      );
    });
  }

  focusInputField() {
    const input = document.getElementsByClassName('focus-text-input')[0] as HTMLInputElement;
    if (input && input instanceof HTMLInputElement) {
      input.focus();
    }
  }

  setSortField(value: string) {
    this.sortBy = value;
  }

  loadMoreData() {
    const shouldExit = !!this.lastDataNumber && this.lastDataNumber <= this.totalCount;

    if (shouldExit) return;

    this.searchInfo.start = this.lastDataNumber;
    this.getJobs(true);
  }

  //On error of jobs api call
  onJobsError(_) {
    this.loaderService.hideLoader();
  }

  //To save filter data
  saveFilter() {
    this.loaderService.displayLoader();
    this.localStorageService.setItem('invoicesFilter', JSON.stringify(this.searchInfo));
    this.getJobs();
  }

  //To clear filter data
  clearFilter() {
    this.loaderService.displayLoader();
    this.localStorageService.removeItem('invoicesFilter');
    this.searchInfo = Object.assign({}, this.defaultSearch);
    this.triggerChange('#assistant_id');
    this.triggerChange('#project_manager_id');
    this.triggerChange('#invoice_status');
    this.triggerChange('#status');
    this.triggerChange('#departmentCode');
    this.triggerChange('#ownerId');
    this.triggerChange('#arCustomer');
    this.clearSelect2MultipleWithCheck();
    this.setSelect2MultipleWithCheck();
  }

  //To get all users
  getUsers() {
    //Service call to get all users data
    return new Promise((resolve, reject) => {
      this.usersService.getUsers().subscribe(
        res => {
          this.onUsersSuccess(res);
          resolve(true);
        },
        error => {
          this.onUsersError(error);
          reject(error);
        },
      );
    });
  }

  //On success of users api call
  onUsersSuccess(result) {
    if (!result) {
      return;
    }

    if (result?.data) {
      //Assign users result data to projectManagerData, projectForemanData and ProjectAssistantData
      this.projectManagerData = result.data.filter(function (item) {
        return (item.role_id == 4 || item.role_id == 14) && item.status == 1;
      });
      this.ProjectAssistantData = result.data.filter(function (item) {
        return item.role_id == 7 && item.status == 1;
      });
      this.projectForemanData = result.data.filter(function (item) {
        return item.role_id == 3 && item.status == 1;
      });
    }

    for (const user of this.projectManagerData) {
      this.projectManagerNames[`${user.id}`] = user.employee_alias || user.first_name + ' ' + user.last_name;
    }
    for (const user of this.ProjectAssistantData) {
      this.projectAssistantNames[`${user.id}`] = user.employee_alias || user.first_name + ' ' + user.last_name;
    }
    for (const user of this.projectForemanData) {
      this.projectForemanNames[`${user.id}`] = user.employee_alias || user.first_name + ' ' + user.last_name;
    }
  }

  //On error of users api call
  onUsersError(_) { }

  //To get all arcustomer data
  getARCustomer() {
    return new Promise((resolve, reject) => {
      this.jobsService.getARCustomer().subscribe(
        res => {
          this.onARCustomerSuccess(res);
          resolve(true);
        },
        error => {
          this.onARCustomerError(error);
          reject(error);
        },
      );
    });
  }

  //On success of arcustomer api call
  onARCustomerSuccess(result) {
    if (result?.data) {
      this.arCustomerData = result.data;
    }
  }

  //On error of arcustomer api call
  onARCustomerError(_) { }

  //To get all owner data
  getOwners() {
    return new Promise((resolve, reject) => {
      this.ownerInfoService.getOwners().subscribe(
        res => {
          this.onOwnersSuccess(res);
          resolve(true);
        },
        error => {
          this.onOwnersError(error);
          reject(error);
        },
      );
    });
  }

  //On success of getOwners api call
  onOwnersSuccess(result) {
    if (result?.data) {
      this.ownersData = result.data;
    }
  }

  //On error of getOwners api call
  onOwnersError(_) { }

  //To get all arcustomer data
  getBillingDueDateTypes() {
    return new Promise(resolve => {
      this.billingDueDateTypesService.getWorkingStatus().subscribe(response => {
        if (response?.data) {
          this.dueDateBillingTypeData = response.data;
          this.dueDateBillingTypeDescription.splice(0, 0, '');

          for (const type of this.dueDateBillingTypeData) {
            this.dueDateBillingTypeDescription.splice(type.id, 0, type.name);
          }
        }
        resolve(true);
      });
    });
  }

  //To get all active departments data
  getDepartments() {
    return new Promise((resolve, reject) => {
      this.departmentService.getDepartments().subscribe(
        res => {
          this.onDepartmentsSuccess(res);
          resolve(true);
        },
        error => {
          this.onDepartmentsError(error);
          reject(error);
        },
      );
    });
  }

  //On success of arcustomer api call
  onDepartmentsSuccess(result) {
    if (!result?.data) return;

    this.departmentsData = result.data.filter(dept => dept.status);
  }

  //On error of arcustomer api call
  onDepartmentsError(_) { }

  getInvoicesData() {
    return new Promise(resolve => {
      this.invoicesService.getBillingTypes().subscribe(response => {
        if (response?.data) {
          this.typeOfBillingData = response.data;

          this.typeOfBillingDescription.splice(0, 0, '');
          for (const type of this.typeOfBillingData) {
            this.typeOfBillingDescription.splice(type.id, 0, type.acronym);
          }
        }
      });

      this.invoicesService.getStatusTypes().subscribe(response => {
        if (response?.data) {
          this.invoiceStatusData = response.data;

          this.initInvoiceStatusDescriptions();
          this.buildInvoiceStatusSelectList();
        }
      });
      resolve(true);
    });
  }

  //Initialize the list of job statuses:
  getJobStatuses() {
    return new Promise(resolve => {
      this.jobStatus.push({ name: 'Started', value: '1' });
      this.jobStatus.push({ name: 'Active', value: '2,3,4' });
      this.jobStatus.push({ name: 'Closed', value: '5' });
      this.jobStatus.push({ name: 'Deleted', value: '0' });
      resolve(true);
    });
  }

  initInvoiceStatusDescriptions() {
    for (const status of this.invoiceStatusData) {
      this.invoiceStatusDescription[`${status.id}`] = status.name;
    }
  }

  buildInvoiceStatusSelectList() {
    const sortedList = this.invoiceStatusData.sort((statusA, statusB) => {
      if (statusA.name > statusB.name) return 1;
      if (statusA.name < statusB.name) return -1;
      return 0;
    });

    const optionsList = sortedList.reduce((list, option) => {
      list += `<option value='${option.id}' #sel${option.id}>${option.name}</option>`;
      return list;
    }, '');

    let disabled = 'disabled';
    if (this.userPermissions.invoicing_list.edit) {
      disabled = '';
    }

    this.invoiceStatusOptionsList = `
      <div class='invoice-status-select-wrapper #class'>
        <select ${disabled} class='invoice-status-select' id='invoice-status-select-#id'>
          ${optionsList}
        </select>
      </div>
    `;
  }

  //Set search parameter and get filter data
  searchInTable(...args: any[]) {
    this.loaderService.displayLoader();
    for (let i = 0; i + 1 < args.length; i += 2) {
      this.searchInfo[args[i + 1]] = args[i];
      this.closeFilterModel.nativeElement.click();
    }
    this.searchInfo.start = 0;
    this.clearHTMLforTag('#invoiceTable');
    this.getJobs();
  }

  //To get all working status
  getWorkingStatus() {
    //Service call to get all working status data
    return new Promise((resolve, reject) => {
      this.workingStatusService.getWorkingStatus().subscribe(
        res => {
          this.onWorkingStatusSuccess(res);
          resolve(true);
        },
        error => {
          this.onWorkingStatusError(error);
          reject(false);
        },
      );
    });
  }

  //On success of working status api call
  onWorkingStatusSuccess(result) {
    if (!result?.data) return;

    this.workingStatusData = result.data;
  }

  //On error of working status api call
  onWorkingStatusError(_) { }

  //To formate date in chat box
  getFormattedDate(date: string) {
    if (!date) return '';

    return this.momentService.getGeneralDateFormat(date, 'M/DD/YYYY h:mm A');
  }

  sortInvoiceCustomerData(type) {
    const data = type.split(',');

    if (data[1].trim() === 'asc') {
      this.type = 'desc';
    } else {
      this.type = 'asc';
    }

    this.searchInfo.sort_order = this.type;
    this.searchInfo.sort_field = data[0];
    this.searchInfo.start = 0;
    this.getJobs(true);
  }

  async getNotes(jobId: number, commentType: string) {
    //Service call to get all working comments data
    const res = await this.potentialJobsWorkingCommentsService
      .getPotentialJobsWorkingCommentsByJobId(jobId, commentType, {
        includeInvoices: 1,
      })
      .toPromise();

    return this.parseNotesToColumn(res.data);
  }

  getReadableDate(created_date: string) {
    return this.momentService.getGeneralDateFormat(created_date, 'M/DD/YYYY');
  }

  parseNotesToColumn(data) {
    const lastSix = data.slice(-6);

    const res = lastSix.map(
      el => `${el.user_name} on ${this.getReadableDate(el?.created_date)} commented: ${el.comment}\n`,
    );

    return res.join(',').replaceAll(',', '');
  }

  async generateCSV() {
    if (!this.jobsData.length) {
      this.toastService.showToast('No data to export.', 'error');
      return;
    }
    const reportDate = this.momentService.getGeneralDateFormat('', 'MM-DD-YYYY_h:mm A');
    const options = {
      filename: `Invoicing_${reportDate}`,
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
    };

    const csvExporter = new ExportToCsv(options);

    const promiseArr = this.jobsData.map(async job => {
      job.job_creation_date = job.job_creation_date ? job.job_creation_date.split('T')[0] : '';

      return {
        Assistant: job.main_assistant_name || '',
        'Project Manager': job.main_project_manager_name || '',
        Foreman: job.main_foreman_name || '',
        'Invoice Status': this.invoiceStatusDescription[job.invoice_status],
        'Last Invoice Date': job.jobLastInvoiceDate || '',
        'Project Name': job.name || '',
        'Job #': job.number || '',
        Departments: job.departments_list || '',
        'Job Created': job.job_creation_date || '',
        'Bill Due': job.contact_billing_due_date_type || '',
        'Billing Type': job.contact_type_of_billing || '',
        'Customer ID': job.customer_code || '',
        'PO #': job.contact_purchse_order || '',
        'Job Notes': await this.getNotes(job.id, 'job'),
        'Accounting Notes': await this.getNotes(job.id, 'acct'),
        'Contract Total': this.formatToCurrency(job.contractTotal),
        'Estimated Cost': this.formatToCurrency(job.estCostTotal),
        'JTD Cost': this.formatToCurrency(job.jtdCostTotal),
        'JTD Billed': this.formatToCurrency(job.jtdBilledTotal),
        'JTD Profit': this.formatToCurrency(job.jtdProfitTotal),
        'Open AR': this.formatToCurrency(job.openARTotal),
      };
    });

    const dataForExport = await Promise.all(promiseArr);

    csvExporter.generateCsv(dataForExport);
  }

  checkIsSelected(id: string, type: string) {
    const searchData = this.searchInfo[type];

    return searchData.includes(id);
  }

  formatToInteger(amt: string): number {
    if (amt) {
      return parseInt(amt.replace(/\.|\,/g, '')); // remove commas and decimal
    }
    return 0;
  }

  formatToCurrency(amt: number) {
    let isNegative = false;
    if (amt < 0) {
      isNegative = true;
      amt *= -1;
    }

    const currency = (amt / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
    });
    return isNegative ? `($${currency})` : `$${currency}`;
  }
  addNegativeSpan(value: string) {
    return value[0] === '(' ? `<span class='negative'>${value}</span>` : value;
  }

  updateAccountingNotesSection(element, jobId, commentType) {
    return this.getMessages(jobId, commentType)
      .then(() => {
        const messages = this.messages.slice(Math.max(this.messages.length - 3, 0));
        return messages.reduce((list, msg) => {
          list += `
            <div class='note ${msg.user_id == this.userId ? 'self' : ''}'>
              <div class='note-header'>${msg.user_name}, ${msg.created_date}</div>
              <div class='note-message'>${msg.comment}</div>
            </div>
          `;
          return list;
        }, '');
      })
      .then(messagesMarkup => {
        if (!messagesMarkup.length) {
          messagesMarkup =
            '<div class="note"><div class="note-header">...</div><div class="note-message">No messages found.</div></div>';
        }
        this.renderer2.setProperty(element, 'innerHTML', messagesMarkup);
      });
  }

  //To get ip address of client
  getIP() {
    this.ipAddressService.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  //To create job audit trail
  createJobAuditTrail(auditTrailArr) {
    this.jobAuditTrailService
      .createJobAuditTrail(auditTrailArr)
      .toPromise()
      .catch(error => console.error('createJobAuditTrail error:', error));
  }

  getJobId(target: HTMLElement): string {
    const x = target.id;
    return x.substring(x.lastIndexOf('-') + 1);
  }

  resetInvoices() {
    this.loaderService.displayLoader();
    const resetPayload = {
      user_id: this.userId,
      ip_address: this.ipAddress,
      last_reset_date: this.momentService.getDBDateTimeFormat(),
    };
    this.invoicesService
      .resetInvoices(resetPayload)
      .toPromise()
      .then(response => {
        this.toastService.showToast(response.data, 'success');
      })
      .catch(response => {
        let message = response?.error?.errors?.message || 'Unknown error occurred';
        message = message.replace(/\'/g, '"');
        this.toastService.showToast(message, 'error');
      })
      .finally(() => this.getJobs(true));
  }

  // Attaches click listener to button, which triggers display of modal
  // This is here, to help eliminate jQuery dependence.
  addModalListenerToCommentButtons(className, commentType) {
    const commentElements = window.document.getElementsByClassName(className);
    Array.from(commentElements).forEach(el => {
      this.renderer2.listen(el, 'click', event => {
        const jobId = this.getJobId(event.currentTarget);

        this.assignChatJobId(jobId, commentType);
        this.chatModal.getMessages(jobId, commentType);
      });
    });
  }

  // Attaches keyup.enter listener to input, which triggers a method to save the input
  // to the database
  // This is here, to help eliminate jQuery dependence.
  addCreateMsgListenerToTxtInputElement() {
    const commentElements = window.document.getElementsByClassName('commentTxt');
    Array.from(commentElements).forEach(el => {
      this.renderer2.listen(el, 'keyup.enter', event => this.createUpdateAcctNoteFromInput(event));
    });
  }

  createUpdateAcctNoteFromInput(event) {
    const jobId = this.getJobId(event.currentTarget);

    const commentType = 'acct';
    this.createMessage(jobId, event.currentTarget.value, this.userId, commentType).then(() => {
      this.updateAccountingNotesSection(window.document.getElementById(`note-list-${jobId}`), jobId, commentType);
    });
  }

  // Attaches click listener to button, which triggers a method to save the input
  // to the database
  // This is here, to help eliminate jQuery dependence.
  addCreateMsgListenerToSubmitButton() {
    const commentElements = window.document.getElementsByClassName('commentBtn');
    Array.from(commentElements).forEach(el => {
      this.renderer2.listen(el, 'click', event => this.createUpdateAcctNoteFromButton(event));
    });
  }

  createUpdateAcctNoteFromButton(event) {
    const jobId = this.getJobId(event.currentTarget);

    const commentType = 'acct';
    const input = <HTMLInputElement>window.document.getElementById(`commentTxt-${jobId}`);
    this.createMessage(jobId, input.value, this.userId, commentType).then(() => {
      this.updateAccountingNotesSection(window.document.getElementById(`note-list-${jobId}`), jobId, commentType);
    });
  }

  // Attaches custom event listener (refresh-chat-event) to note-list div's,
  // which triggers a method to get accounting notes from database and update the DOM
  // This is here, to help eliminate jQuery dependence.
  addRefreshNotesListenerToNoteListSection() {
    const noteList = window.document.getElementsByClassName('note-list');
    Array.from(noteList).forEach(el => {
      this.renderer2.listen(el, 'refresh-chat-event', event => {
        this.renderer2.setProperty(el, 'innerHTML', '');
        const jobId = this.getJobId(event.currentTarget);

        this.updateAccountingNotesSection(el, jobId, 'acct');
      });
    });
  }

  // Attaches change event listener to invoice status select's,
  // which triggers a method to change the background color and (eventually) submit the change to the backend
  // This is here, to help eliminate jQuery dependence.
  addChangeListenerToInvoiceStatusSelect() {
    const selectList = window.document.getElementsByClassName('invoice-status-select');

    Array.from(selectList).forEach(el => {
      this.renderer2.listen(el, 'focus', event => {
        el['oldValue'] = event.currentTarget.value;
      });

      this.renderer2.listen(el, 'change', event => this.updateInvoiceStatus(event, el));
    });
  }
  updateInvoiceStatus(event, el) {
    const oldValue = el['oldValue'];
    const newValue = event.currentTarget.value;
    const select = <HTMLDivElement>el.parentNode;
    const selectElement = event.currentTarget; // used to reset value, if error caught
    const oldClass = `selected-${this.invoiceStatusDescription[oldValue].toLowerCase().replace(/ /g, '-')}`;
    const newClass = `selected-${this.invoiceStatusDescription[newValue].toLowerCase().replace(/ /g, '-')}`;
    const jobId = this.getJobId(event.currentTarget);

    const invoiceRecord = {
      job_id: jobId,
      user_id: this.userId,
      invoice_status_id: newValue,
    };

    this.jobsData.filter(job => jobId == job.id).forEach(job => (job.invoice_status = newValue));

    this.invoicesService
      .createUpdateInvoiceStatusRecord(invoiceRecord)
      .toPromise()
      .then(response => {
        if (response.errors) {
          console.error(response);
          throw new Error();
        }

        select.classList.replace(oldClass, newClass);
        select.classList.remove('fail', 'fail-finished', 'success-finished');
        select.classList.add('success');
        setTimeout(() => {
          select.classList.add('success-finished');
          select.classList.remove('success');
        }, 225);

        el['oldValue'] = newValue;

        // Add entry to audit trail
        const auditTrail = {
          job_id: jobId,
          user_id: this.userId,
          ip_address: this.ipAddress,
          action: 3,
          status_from: oldValue,
          status_to: newValue,
          created_date: this.momentService.getDBDateTimeFormat(),
        };
        this.createJobAuditTrail(auditTrail);

        // Add messages to chat re: change to invoice status
        const message = `Updated invoice status: ${this.invoiceStatusDescription[oldValue]} to ${this.invoiceStatusDescription[newValue]}`;
        this.createMessage(jobId, message, this.userId, 'invc').then(() => {
          this.updateAccountingNotesSection(window.document.getElementById(`note-list-${jobId}`), jobId, 'acct');
        });
      })
      .catch(error => {
        // if error caught, change value back to prev value
        console.error(error);
        select.classList.remove('success', 'success-finished', 'fail-finished');
        select.classList.add('fail');
        setTimeout(() => {
          select.classList.add('fail-finished');
          select.classList.remove('fail');
        }, 225);
        selectElement.value = oldValue;
      });
  }

  // Attaches click listener to button, which triggers a method to save the input
  // to the database
  // This is here, to help eliminate jQuery dependence.
  addPrintPdfListenerToPrinterButton() {
    const commentElements = window.document.getElementsByClassName('btn-printer-acct');
    Array.from(commentElements).forEach(el => {
      this.renderer2.listen(el, 'click', event => {
        const jobIdString = this.getJobId(event.currentTarget);
        const jobId = parseInt(jobIdString);

        const jobRecord = this.jobsData?.find(job => job.id === jobId);
        const department = jobRecord?.department_codes ?? 'no department';

        this.updateMessagesPdf({ jobId, commentType: 'acct', department });
      });
    });
  }

  updateMessagesPdf({ jobId, commentType, department }) {
    this.messagesPdf.updateParams(jobId, commentType, this.projectNames[jobId], this.jobNumbers[jobId], department);
  }

  /**
   *
   * jQuery Helpers Section
   *
   */

  loadToggle() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadInvoiceToggle();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  loadTooltip() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadTooltip();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  loadScroller() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadScroller();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  appendHTMLtoTag(obj, content) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = 'appendHTMLtoTag("' + obj + '",`' + content + '`);';
    this.renderer2.appendChild(this._document.body, s);
  }

  scrollToBottom(obj) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = 'scrollToBottom("' + obj + '");';
    this.renderer2.appendChild(this._document.body, s);
  }

  clearHTMLforTag(obj) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = 'clearHTMLforTag("' + obj + '");';
    this.renderer2.appendChild(this._document.body, s);
  }

  triggerChange(obj) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `triggerChange('` + obj + `');`;
    this.renderer2.appendChild(this._document.body, s);
  }

  loadSelect2() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadSelect2();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  loadSelect2MultipleWithCheck(className = '.select2MultipleWithCheck') {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadSelect2MultipleWithCheck('` + className + `','Working Status');`;
    this.renderer2.appendChild(this._document.body, s);
  }

  clearSelect2MultipleWithCheck(className = '.select2MultipleWithCheck') {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `clearSelect2MultipleWithCheck('` + className + `');`;
    this.renderer2.appendChild(this._document.body, s);
  }

  setSelect2MultipleWithCheck(className = '.select2MultipleWithCheck', searchInfo = {}) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `setSelect2MultipleWithCheck('` + className + `', [` + searchInfo['working_status'] + `]);`;
    this.renderer2.appendChild(this._document.body, s);

    const s1 = this.renderer2.createElement('script');
    s1.type = 'text/javascript';
    s1.text = `setSelect2MultipleWithCheck('` + className + `', [` + searchInfo['status'] + `]);`;
    this.renderer2.appendChild(this._document.body, s1);

    const s2 = this.renderer2.createElement('script');
    s2.type = 'text/javascript';
    s2.text = `setSelect2MultipleWithCheck('` + className + `', [` + searchInfo['invoice_status'] + `]);`;
    this.renderer2.appendChild(this._document.body, s2);
  }

  loadInvoiceDataOnScroll() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadInvoiceDataOnScroll();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  destroyUpdateDataTable(table = '.jobs-invoice-data-table') {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `destroyUpdateDataTable('${table}');`;
    this.renderer2.appendChild(this._document.body, s);
  }

  //To clear datatable
  clearDatatable(table = '.jobs-invoice-data-table') {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `clearDatatable('${table}')`;
    this.renderer2.appendChild(this._document.body, s);
  }

  //To clear datatable
  updateDatatable(table = '.jobs-invoice-data-table') {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `updateDatatable('${table}')`;
    this.renderer2.appendChild(this._document.body, s);
  }

  //To draw datatable with data
  drawDatatable(table = '.jobs-invoice-data-table') {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `reloadDataTable('${table}')`;
    this.renderer2.appendChild(this._document.body, s);
  }

  sortInvoiceData(_, field, type = null) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `sortInvoiceData('.newInvoiceCustomerSortData','` + field + `','` + type + `')`;
    this.renderer2.appendChild(this._document.body, s);
  }

  addCollapseListeners() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `addCollapseListeners()`;
    this.renderer2.appendChild(this._document.body, s);
  }
}
